import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip, Typography } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import CreateIcon from "@mui/icons-material/Create";

//Srcs
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import LevelForm from "./LevelForm";
import DeleteForm from "../Include/DeleteForm";

import { DELETE_LEVEL } from "../../Schema/Level";

export default function LevelAction({ editData, setRefetch }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //======================== delete =========================
  const [deleteLevel] = useMutation(DELETE_LEVEL, {
    onCompleted: ({ deleteLevel }) => {
      // console.log("deleteLevel::", deleteLevel);
      setLoading(false);
      if (deleteLevel?.is_success === true) {
        setAlert(true, "success", deleteLevel?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteLevel?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteLevel({
      variables: {
        id: editData?._id,
      },
    });
  };


  return (
    <div>
      <Stack direction="row" justifyContent="right" alignItems="center">
        {editData?.after_finish === null ? (
          <Typography className={language === "en" ? "require-need" : "require-need-kh"}>{t("update_needed")}</Typography>
        ) : null}
        <Tooltip title={t("tooltip-update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <CreateIcon className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("tooltip-delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <LevelForm
        dialogTitle="Update"
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
      <DeleteForm
        open={openDel}
        handleClose={handleCloseDel}
        title="dialog_title_delete_grade_level"
        confirmVal="Level"
        handleDelete={handleDelete}
      />
    </div>
  );
}
